import React, { useState, useEffect } from "react";
import { sendData } from "../../services/auth";
import { uriList } from "../../helpers/config";
import { width } from "../../helpers";
import './style.scss'
import ModalMap from './modal-map'
import ModalHistory from './modal-history'
import ModalEditOS from './modal-editOS'
import ModalShowSignature from './modal-showSignature'
import ModalAPR from './modal-apr'
import * as moment from "moment";
import { startOfMonth, endOfMonth, format } from 'date-fns'
import { Pagination, InputLabelAlert } from '../../common/layout'

const Atendimento = (props) => {
    const [pesquisa, setPesquisa] = useState("");
    const [actualPage, setActualPage] = useState(0);
    const [qtdLinesPage, setQtdLinesPage] = useState(10);
    const [modal, setModal] = useState(false);
    const [modalHistory, setModalHistory] = useState(false)
    const [modalEditOS, setModalEditOS] = useState(false)
    const [showmodalAPR, setShowModalAPR]       = useState(false)
    const [showmodalSignatureAPR, setShowmodalSignatureAPR] = useState(false)
    const [carregando, setCarregando] = useState(false);
    const [loading, setLoading] = useState(false)
    const [Contagens, setContagens] = useState([]);
    const [allDocuments, setAllDocuments] = useState([]);

    const [locations, setLocations] = useState([])
    const [history, setHistory] = useState([])
    const [data, setData] = useState([])
    const [mapData, setMapData] = useState({})

    const [startDate, setStartDate] = useState(format(startOfMonth(new Date()), 'yyyy-MM-dd'))
    const [endDate, setEndDate] = useState(format(endOfMonth(new Date()), 'yyyy-MM-dd'))
    const [typeData, setTypeData] = useState(0)
    const [typeSignWeb, setTypeSignWeb] = useState(0)

    async function _getData() {
        setCarregando(true)

        await sendData({
            uri: uriList("buscarAtendimento"), content: {
                startDate,
                endDate,
                typeData
            }
        })
            .then((res) => {
                console.log('Resposta completa da API:', res)
                
                if (res.status && parseInt(res.status) > 200) throw new Error();
                if (res._status && parseInt(res._status) > 200) throw new Error();
                
                let _data = []
                
                // Os dados vêm diretamente no objeto res, com chaves sendo os IDs dos documentos
                // Filtra as chaves que não são metadados (como _status)
                const keys = Object.keys(res).filter(key => !key.startsWith('_'))
                
                if (keys.length > 0) {
                    _data = keys.map(key => ({
                        ...res[key],
                        ref: key // Mantém a referência do documento
                    }))
                }
                
                console.log('Dados processados:', _data)
                console.log('Quantidade de registros:', _data.length)
                
                console.log(typeSignWeb)
                let _filter
                switch (parseInt(typeSignWeb)) {
                    case 0:
                        setAllDocuments(_data)
                        setContagens(_data)
                        break;
                    case 1:
                        _filter = _data.filter(_reg => {
                            return !_reg.signaprweb
                        })
                        setAllDocuments(_filter)
                        setContagens(_filter)
                        break;
                    case 2:
                        _filter = _data.filter(_reg => {
                                return _reg.signaprweb === true
                            })
                            console.log(_filter)
                            setAllDocuments(_filter)
                            setContagens(_filter)
                            break;
                    default:
                        break;
                }
                
            })
            .catch((e) => {
                console.log(e);
                // alert("Erro ao obter Contagens.\n" + e.message);
            });
        setCarregando(false)
    }

    useEffect(() => {
        _getData();
    }, []);


    function handlePage(e) {
        setActualPage(parseInt(e.currentTarget.value));
    }

    function handlePesquisa(e) {
        if (e) {
            let _data = allDocuments.filter(_item => {
                return _item.client?.toString().toLowerCase().indexOf(e.target.value.toString().toLowerCase()) >= 0
            })

            setContagens(_data)
            setPesquisa(e.target.value)
        } else {
            setContagens(allDocuments)
            setPesquisa('')
        }
    }

    const handleShowMap = (_data) => {
        console.log('Dados do atendimento:', _data)
        console.log('Locations do atendimento:', _data.locations)
        setLocations(_data.locations || [])
        setMapData(_data)
        setModal(true)
    }

    const handleEditOS = (_data) => {
        setData(_data)
        setModalEditOS(true)
    }

    const handleAPR = (_data) => {
        setData(_data)
        setShowModalAPR(true)
    }

    const handleCloseModal = () => { setModal(false) }
    const handleCloseModalHistory = () => { setModalHistory(false) }
    const handleCloseModalAPR = () => { setShowModalAPR(false)
        _getData()
     }
    const handleCloseModalSignatureAPR = () => { setShowmodalSignatureAPR(false) 
        _getData()
    }
    const handleCloseModalEditOS = () => {
        setModalEditOS(false)
        _getData()
    }

    const handeShowHistory = (_data) => {
        setHistory(_data.attendance_items || [])
        setModalHistory(true)
    }

    const isShowSignature = (_data) => {
        // Nova estrutura: verifica se existe signresponsavel ou signtecnico
        return !!(_data?.signresponsavel || _data?.signtecnico)
    }

    const handleShowSignture = (_data) => {
        if (isShowSignature(_data)) {
            setShowmodalSignatureAPR(true)
            setData(_data)
        }
       
    }
    
    // Função auxiliar para calcular KM total baseado nas locations
    const calcularKM = (_data) => {
        if (_data.km) return _data.km
        // Se não tiver km calculado, retorna 0
        return 0
    }
    
    return (
        <div style={{ height: "80vh", overflowY: "auto" }}>
            {mapData && <ModalMap data={mapData} locations={locations || []} show={modal} onClose={handleCloseModal} />}
            {modalHistory && <ModalHistory item={history || []} show={modalHistory} onClose={handleCloseModalHistory} />}
            {modalEditOS && <ModalEditOS item={data || []} show={modalEditOS} onClose={handleCloseModalEditOS} />}
            {showmodalAPR && <ModalAPR item={data || []} show={showmodalAPR} onClose={handleCloseModalAPR} />}
            {showmodalSignatureAPR && <ModalShowSignature item={data || []} show={showmodalSignatureAPR} onClose={handleCloseModalSignatureAPR} />}

            <div
                style={{
                    flexDirection: width() == "mobile" ? "column" : "",
                    alignItems: "center",
                    justifyContent: "center",
                    padding: "10px",
                }}
            >
                <div className={`${width() == "mobile" ? "" : "mb-5"} col-md-12`}>
                    <div className={`${width() == "mobile" ? "h3" : "h1"} center-elements`}>Atendimento de OS</div>
                </div>

                <div className="col-md-12 mb-2">
                    <div className={`p-0 ${width() == "mobile" ? "d-block" : "d-flex"} menu-atendimento`} style={{ gap: "10px" }}>
                        <div style={{ display: "flex", gap:"7px", flexWrap: "wrap" }}>
                            <div className="input-data">
                                <label>Data</label>
                                <select className="form-select" style={{color:"#495057",fontSize: "0.8rem"}} value={typeData} onChange={e => setTypeData(e.target.value)}>
                                    <option value='0'>Atendimento</option>
                                    <option value='1'>Assinatura APR</option>
                                </select>
                            </div>
                            <div className="input-data">
                                <label>Inicial</label>
                                <input type="date" className='form-control' value={startDate} onChange={e => setStartDate(e.target.value)} />
                            </div>

                            <div  className="input-data">
                                <label>Final</label>
                                <input type="date" className='form-control' value={endDate} onChange={e => setEndDate(e.target.value)} />
                            </div>
                            <div className="input-data">
                                <label>Atend. Assinado</label>
                                <select className="form-select" style={{color:"#495057",fontSize: "0.8rem"}} value={typeSignWeb} onChange={e => setTypeSignWeb(e.target.value)}>
                                    <option value='0'>Todos</option>
                                    <option value='1'>Não assinados</option>
                                    <option value='2'>Assinados</option>
                                </select>
                            </div>
                        </div>
                        <div className="input-search" style={{ justifyContent: "flex-end", display: "flex", flexDirection: "column" }}>
                            <InputLabelAlert
                                type="text"
                                label="Pesquisa"
                                id="pesquisa"
                                cifrao={false}
                                value={pesquisa}
                                handle={handlePesquisa}
                                focus={true}
                            />
                        </div>

                        <div className={`${width() == "mobile" ? " col-12 mb-2" : "ml-2"} `} style={{ display: "flex", gap: "5px", padding: "10px 0px 0px 0px", }}>
                            <div style={{ display: "flex", alignItems: "flex-end" }}>
                                <button className="btn btn-success" style={{ width: "100px" }} disabled={loading} onClick={e => _getData()} title="Filtrar por período selecionado">{loading ? <i className="fa fa-spinner fa-spin" /> : <i className="fa fa-filter" />} Pesquisar</button>
                            </div>
                            {/* <div style={{ justifyContent: "flex-end", display: "flex", flexDirection: "column" }}>
                                <button className={`${width() == "mobile" ? "" : "ml-1 "} btn btn-secondary `} style={{ width: "100px" }} onClick={e => { handlePesquisa() }} >
                                    <i className="fa fa-ban" /> Limpar
                                </button>
                            </div> */}

                        </div>
                    </div>
                </div>

                <div className="col-md-12" style={{ overflowX: "auto", }}>
                    {/* <div className="border rounded p-1 mb-1"> */}
                    <div>
                        <table className="table table-striped table-hover mb-1 rounded " >
                            <thead className="thead-dark">
                                <tr>

                                    <th scope="col" style={{ width: "25%" }}>Cliente</th>
                                    <th scope="col" style={{ width: "15%" }}>Técnico</th>
                                    <th scope="col" style={{ width: "12%" }}>Inicio</th>
                                    <th scope="col" style={{ width: "12%" }}>Fim</th>
                                    <th scope="col" style={{ width: "7%" }}>KM</th>
                                    <th scope="col" style={{ width: "7%" }}>OSID</th>
                                    <th scope="col" style={{ width: "5%" }}>Data APR</th>
                                    <th scope="col" style={{ width: "5%" }}>Responsável APR</th>
                                    <th
                                        scope="col"
                                        style={{ width: "10%" }}
                                        className="text-center"
                                    >
                                        Ações
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {(!Contagens || Contagens.length === 0) && <tr><td colSpan="9">Nenhum registro encontrado</td></tr>}
                                {Contagens && Contagens.length > 0 && Contagens.map((contagem, index) => {
                                    const page = parseInt(actualPage) || 0
                                    const linesPerPage = parseInt(qtdLinesPage) || 10
                                    if (index < page * linesPerPage || index >= (page + 1) * linesPerPage) {
                                        return null
                                    }
                                    return (
                                                <tr key={contagem.id || index} style={{
                                                    cursor: "pointer",
                                                }}
                                                    onDoubleClick={() => handleEditOS(contagem)} >
                                                    <td ><span className="margin-left-5">{contagem.client}</span></td>
                                                    <td ><span className="margin-left-5">{contagem.userName}</span></td>

                                                    {width() != "mobile" && <td style={{ width: "10%" }}><span className="margin-left-5">{moment(contagem.startDate).format('DD/MM/YYYY HH:mm')}</span></td>}
                                                    {width() != "mobile" && <td style={{ width: "10%" }}><span className="margin-left-5">{contagem.endDate ? moment(contagem.endDate).format('DD/MM/YYYY HH:mm') : '-'}</span></td>}
                                                    <td><span className="margin-left-5">{(calcularKM(contagem) || 0).toFixed(2)}</span></td>
                                                    <td><span className="margin-left-5">{contagem.osid}</span></td>
                                                    <td>{contagem.dataresponsavel ? moment(contagem.dataresponsavel).format('DD/MM/YYYY HH:mm') : '-'}</td>
                                                    <td>{contagem.responsavel}</td>
                                                    <td style={{ width: "10%" }}>
                                                        <div className="d-flex justify-content-center" style={{ overflow: 'hidden', gap: "5px" }}>
                                                            <button className="btn btn-sm btn-primary" onClick={e => handleShowMap(contagem)} title="Visualizar Percurso">
                                                                <i className="fa fa-map-location-dot" />
                                                            </button>
                                                            <button className="btn btn-sm btn-secondary" onClick={e => handeShowHistory(contagem)} title="Histórico de Atendimento">
                                                                <i className="fa fa-history" />
                                                            </button>
                                                            <button className="btn btn-sm btn-success" onClick={e => handleEditOS(contagem)} title="Edição de OS">
                                                                <i className="fa fa-user-pen" />
                                                            </button>
                                                            <button className="btn btn-sm btn-primary" onClick={e => handleAPR(contagem)} title="Edição de APR" disabled={!contagem.aprData}>
                                                                <i className="fa fa-id-badge" />
                                                            </button>
                                                            <button className="btn btn-sm btn-secondary" disabled={!isShowSignature(contagem)}
                                                            onClick={e => handleShowSignture(contagem)} title="Visualizar assinatura Técnico e Responsável">
                                                                <i className="fa fa-file-signature" />
                                                            </button>
                                                        </div>
                                                    </td>
                                                </tr>
                                    )
                                })
                                }
                            </tbody>
                            <tr>
                                <td colSpan="12" className="text-left">
                                    Total de Registros: {Contagens && Contagens.length}
                                </td>
                            </tr>
                        </table>
                    </div>
                    <Pagination
                        detailed={Contagens}
                        actual={actualPage}
                        changePage={handlePage}
                        setQtdLinesPage={setQtdLinesPage}
                    />
                </div>
            </div>
        </div>
    );
}

export default Atendimento;

